<style scoped>
.windowtimecontainer {
  overflow-y: scroll;
  margin-left: 5.5rem;
  margin-top: 1rem;
  position: absolute;
  z-index: 1;
}
.windowtimecontainermobile {
  overflow-y: scroll;
  z-index: 1;
  margin-left: 1.5rem;
}

.telemetrysample {
  overflow-y: scroll;
  margin-top: 0.5rem;
  position: absolute;
  top: 12rem;
  z-index: 10;
}
.telemetrysamplemobile {
  overflow-y: scroll;
  margin-top: 0.5rem;
  left: 1rem;
  position: fixed;
  top: 1rem;
  z-index: 10;
}

.telemetry-top-bar {
  background-color: #39a9dc;
}


</style>
<template>
  <v-container
    fill-height
    fluid
    style="
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      overflow-y: scroll;
      padding: 0;
    "
  >
    <v-btn
      v-on:click="drawer = !drawer"
      absolute
      bottom
      fab
      style="z-index: 3; bottom: 1rem; left: 1rem"
      dark
      color="#39a9dc"
      ><v-icon>menu</v-icon></v-btn
    >
    <v-layout row wrap>
      <v-navigation-drawer
        absolute
        v-model="drawer"
        :temporary="
          ($vuetify.breakpoint.sm | $vuetify.breakpoint.xs) ? true : false
        "
        :style="'width: 30rem;padding:1rem;left:' + (!drawer ? '-30rem' : '')"
      >
        <v-btn
          v-on:click="drawer = !drawer"
          top right
          absolute
          style="z-index: 3; top: 0.5rem;"
          dark
          flat icon
          color="#39a9dc"
          ><v-icon>menu</v-icon></v-btn
        >
        <div style="text-align: left; margin: 0.5rem; margin-bottom: 0.5rem">
          <div class="headline">Filters</div>
          <div class="body-1">
            Select devices and window time from here to retrieve related
            geo-location data.
          </div>
        </div>
        <v-form ref="form" v-model="validForm" lazy-validation>
          <v-layout
            row
            wrap
            align-center
            style="padding-left: 1rem; padding-right: 1rem; margin-bottom: 1rem"
          >
            <v-flex xs12 sm12 md12>
              <v-combobox
                color="#39a9dc"
                prepend-icon="memory"
                v-model="selectedDevices"
                label="Select devices"
                :items="devices"
                item-value="id"
                item-text="label"
                multiple
                chips
                return-object
                :rules="selectedDeviceRules"
                required
              >
                <template v-slot:selection="data">
                  <v-chip
                    class="font-weight-bold v-chip--select-multi"
                    color="#FFD300"
                    style="padding: 0.3rem"
                    :key="JSON.stringify(data.item)"
                    :selected="data.selected"
                    :disabled="data.disabled"
                    @input="data.parent.selectItem(data.item)"
                  >
                    <v-avatar>
                      <v-icon color="#39a9dc" dark>memory</v-icon>
                    </v-avatar>
                    {{ data.item.label }}
                  </v-chip>
                </template>
              </v-combobox>
            </v-flex>
            <v-flex xs12 sm12 align-center>
              <v-select
                color="#39a9dc"
                :disabled="selectedDevices.length == 0"
                prepend-icon="date_range"
                v-model="selectedWindowTime"
                label="Select window time"
                :items="windowTimes"
                item-value="id"
                item-text="label"
                return-object
                required
                :rules="windowTimeRules"
              ></v-select>

              <v-chip
                v-if="selectedStartTime.timeObj"
                v-on:click="openDataPicker = true"
                color="#002052"
                dark
                style="float: left; margin-top: 0.5rem"
              >
                <v-avatar
                  ><v-icon color="green" dark>access_time</v-icon></v-avatar
                >
                {{
                  selectedStartTime.timeObj
                    ? selectedStartTime.timeObj.toLocaleTimeString() +
                      " - " +
                      selectedStartTime.timeObj.toLocaleDateString()
                    : ""
                }}
              </v-chip>
              <v-chip
                v-if="selectedEndTime.timeObj"
                v-on:click="openDataPicker = true"
                color="#002052"
                dark
                style="float: left; margin-top: 0.5rem; margin-bottom: 1rem"
              >
                <v-avatar
                  ><v-icon color="red" dark>access_time</v-icon></v-avatar
                >
                {{
                  selectedEndTime.timeObj
                    ? selectedEndTime.timeObj.toLocaleTimeString() +
                      " - " +
                      selectedEndTime.timeObj.toLocaleDateString()
                    : ""
                }}
              </v-chip>

              <v-btn
                outline
                color="#39a9dc"
                style="width: 100%; margin-left: 0rem"
                v-on:click="submit"
              >
                <v-icon>play_arrow</v-icon>
                Submit
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>

        <div
          style="
            text-align: left;
            margin: 0.5rem;
            margin-bottom: 2rem;
            margin-top: 3rem;
          "
        >
          <div class="headline">Geo-fencing</div>
          <div class="body-1">
            Show and fetch geo-fence perimeters defined for the selected
            devices.
          </div>
        </div>
        <v-form>
          <v-layout
            row
            wrap
            align-center
            style="
              padding-left: 1rem;
              padding-right: 1rem;
              margin-bottom: 0.5rem;
            "
          >
            <v-switch
              color="#39a9dc"
              v-model="showGeofence"
              :label="`Show geo-fence perimeters`"
            ></v-switch>
            <v-btn
              outline
              color="#39a9dc"
              style="width: 100%; margin-left: 0rem"
              v-on:click="fetchPerimeters"
            >
              <v-icon style="margin-right: 0.5rem">sync</v-icon>
              Fetch perimeters
            </v-btn>
          </v-layout>
        </v-form>

        <div
          style="
            text-align: left;
            margin: 0.5rem;
            margin-bottom: 2rem;
            margin-top: 3rem;
          "
        >
          <div class="headline">Map configurations</div>
          <div class="body-1">
            Customize map with labels and so on.
          </div>
        </div>

        <v-form>

          <v-layout
            row
            wrap
            align-center
            style="
              padding-left: 1rem;
              padding-right: 1rem;
              margin-bottom: 0.5rem;
            "
          >
            <h5>Display a well-knwon place inside the map.</h5>
              <v-layout
                row
                wrap
                align-center
              >
                <v-flex xs10 >
                  <v-select
                    v-model="selectedWkplace"
                    :items="wkplaces"
                    item-text="name"
                    label="Select a well-known place..."
                    persistent-hint
                    return-object
                    single-line
                  ></v-select>
                </v-flex>
                <v-flex xs2 >
                  <v-btn
                    icon
                    v-on:click="selectedWkplace = null"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
          </v-layout>

          <v-divider style="margin-left:1rem; margin-right:1rem;margin-bottom: 1.5rem"></v-divider>
          
          <v-layout
            row
            wrap
            align-center
            style="
              padding-left: 1rem;
              padding-right: 1rem;
              margin-bottom: 0.5rem;
            "
          >
          
            <h5>Add new label widgets over the map.</h5>
            <v-btn
              outline
              :color="!newLabelFlag ? '#39a9dc' : '#FFD300'"
              style="width: 100%; margin-left: 0rem"
              v-on:click="newLabelFlag = true"
            >
              <v-icon style="margin-right: 0.5rem">new_label</v-icon>
              Create new label
            </v-btn>
            <p v-if="newLabelFlag">Click on map to add a new label...</p>

            <v-chip
              :key="l.name"
              v-for="l of labels"
            >
              {{l.name}} 
              <v-btn v-on:click="deleteLabel(l)" small icon style="margin-right:-0.8rem"><v-icon small style="padding-right:3.3rem">mdi clear</v-icon></v-btn>
            </v-chip>

          </v-layout>
        </v-form>
      </v-navigation-drawer>
      <v-flex
        xs12
        :style="
          'height:100%;margin-left:' +
          (!($vuetify.breakpoint.sm | $vuetify.breakpoint.xs) && drawer
            ? '30rem'
            : '0')
        "
      >
        <v-container fill-height fluid style="padding: 0; margin: 0">
          <v-dialog
            ref="dialog"
            v-model="openDataPicker"
            persistent
            lazy
            full-width
            class="white"
            width="869px"
            style="background-color: white"
          >
            <div class="white">
              <v-time-picker
                color="#39a9dc"
                v-model="timeHourStart"
                format="24hr"
                style="padding: 1rem; padding-bottom: 1.85rem"
                width="17.5rem"
                :disabled="!selectedStartTime.timeObj"
              ></v-time-picker>
              <v-date-picker
                color="#39a9dc"
                ref="picker"
                multiple
                v-model="selectedComplexTime"
                min="1950-01-01"
                style="padding: 1rem; padding-bottom: 0"
              >
              </v-date-picker>
              <v-time-picker
                color="#39a9dc"
                v-model="timeHourEnd"
                format="24hr"
                style="padding: 1rem; padding-bottom: 1.85rem"
                width="17.5rem"
                height="15.5rem"
                :disabled="!selectedEndTime.timeObj"
              ></v-time-picker>

              <v-btn flat color="#002052" @click="openDataPicker = false"
                ><v-icon small style="margin-right: 0.5rem">close</v-icon
                >Cancel</v-btn
              >
              <v-btn color="#FFD300" v-on:click="submit"
                ><v-icon small style="margin-right: 0.5rem">send</v-icon
                >OK</v-btn
              >
            </div>
          </v-dialog>

          <v-layout
            white
            style="width: 100%; height: 100%"
            fill-height
            row
            wrap
          >
            <v-flex
              xs12
              sm12  
              style="
                position: relative;
                text-align: left;
                padding: 0.5rem;
                padding-left: 0;
                height: 100%;,
                transition: width 2s;
              "
            >
              <MapView
                style="z-index: 0; width: 100%"
                v-on:clickMap="handleClickMap($event)"
                v-on:clickLabel="handleClickLabel($event)"
                v-on:clickMarker="clickMarkerHandler($event)"
                v-on:clickPath="() => {}"
                v-on:created="createdPerimeterHandler($event)"
                :markers="markers"
                :paths="paths"
                :perimeters="currentPerimeters"
                :labels="showInMaplabels"
                :image="image"
              />
            </v-flex>
            <v-flex 
              v-if="showTelemetry && (markers.length>0 || paths.length>0)"
              style="
                position: absolute;
                text-align: left;
                padding-top: 0;
                padding-right: 0;
                overflow-y: scroll;
                transition: width 2s;
                height:100%;
                max-width:30rem;
                right:0
              "
            >
              <div style="width:100%" class="blue">
              <v-btn @click="showTelemetry=false" small icon color="blue"><v-icon color="white">close</v-icon></v-btn>
              </div>
              <map-telemetry :telemetry="telemetryListSelectedOnMap">
              </map-telemetry>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-snackbar
        :timeout="0"
        :value="geoLocationRealtime"
        :bottom="true"
        :right="true"
      >
        <v-progress-circular
          width="1.7"
          style="width: 1.2rem; margin-right: 10px"
          indeterminate
          color="green"
        ></v-progress-circular>
        <span style="font-weight: bold"
          >Listening geo-location data realtime</span
        >
        <v-btn icon dark v-on:click="stopGeoLocationRealtime">
          <v-icon>pause</v-icon>
        </v-btn>
      </v-snackbar>

      <inprogress
        :dialog="operationInProcess"
        :message="operationInProcessMessage"
      ></inprogress>
    </v-layout>
    <RegisterLabel
      v-if="newLabelCoordinates!=null"
      :coordinates="newLabelCoordinates"
      v-on:abort="setCoordinates(null)"
      v-on:completed="setCoordinates(null)"
    ></RegisterLabel>
  </v-container>
</template>
<script>
import Vue from "vue";
import { mapState } from "vuex";
import Map from "@/components/MapView";
import RegisterLabel from "@/components/route-components/content-components/RegisterLabel";
import MapTelemetry from './content-components/MapTelemetry.vue';
import { DeviceTelemetry, TelemetrySample } from "@/components/models/DeviceTelemetry"
import { OverlayImage } from '../models/Map';

export default {
  name: "Map",

  components: {
    MapView: Map,
    RegisterLabel: RegisterLabel,
    MapTelemetry: MapTelemetry,
  },

  data: function () {
    return {
      image: null,

      selectedOnMapDeviceId: null,

      selectedWkplace: null, 
      selectedWkplaceLayerId: null, 

      newLabelFlag: false,
      newLabelCoordinates: undefined,
      showInMaplabels: [],
      showTelemetry: false,

      showGeofence: false,
      drawer: true,
      validForm: false,
      selectedTimeRules: [(v) => !!v || "Time constrain required"],
      windowTimeRules: [(v) => !!v || "Window time required"],
      selectedDeviceRules: [
        (v) => !!v || "Select at least one device",
        (v) => v.length > 0 || "Select at least one device",
      ],
      icons: {
        message: "message",
        measure: "insert_chart",
        type: "merge_type",
        bat: "battery_charging_full",
        led: "lightbulb",
        gpstime: "timer",
      },
      markers: [],
      paths: [],
      selectedDevices: [],
      timestamps: [],
      openDataPicker: false,
      selectedWindowTime: null,
      selectedTime: {},
      timeHourStart: "00:00",
      timeHourEnd: "23:59",
      selectedComplexTime: [],
      selectedEndTime: {
        timeObj: null,
        time: "",
        timeHour: "23:59",
      },
      selectedStartTime: {
        timeObj: null,
        time: "",
        timeHour: "00:00",
      },
      windowTimes: [
        {
          id: 0,
          label: "Realtime",
        },
        {
          id: 1,
          label: "Last 1h",
        },
        {
          id: 3,
          label: "3h",
        },
        {
          id: 6,
          label: "6h",
        },
        {
          id: -1,
          label: "Custom",
        },
      ],

      typeView: "paths",
    };
  },

  computed: {
    ...mapState({
      devices: (state) => state.devices.devices,
      geoLocations: (state) => state.telemetry.geoLocations,
      geoLocationRealtime: (state) => state.telemetry.listeningRelatime,
      telemetry: (state) => state.telemetry.telemetry,
      events: (state) => state.telemetry.events,
      operationInProcess: "operationInProcess",
      operationInProcessMessage: "operationInProcessMessage",
      perimeters: (state) => state.devices.perimeters,
      labels: (state) => state.map.labels,
      wkplaces: (state) => state.map.wkplaces,
    }),

    newLabelCoordinatesIsSet(){
      return this.newLabelCoordinates !== undefined && this.newLabelCoordinates !== null ;
    },

    augmentedTelemetry(){
      return this.telemetry.map((t) => { t.label = this.devices.find(d => d.id === t.id).label; return t; });
    },

    augmentedEvents(){
      return this.events.map((e) => {e.label = this.devices.find(d => e.id === d.id).label; return e;});
    },

    telemetryListSelectedOnMap() {
      let list = [];
      list.push(
        ...this.augmentedTelemetry
        .filter(t => this.selectedOnMapDeviceId ? t.id === this.selectedOnMapDeviceId : false)
        .map((t) => {
          const deviceEvents = this.augmentedEvents.find(ae => ae.id === t.id);
          const events = deviceEvents ? deviceEvents.data : [];
          const samples = [];
          t.data
            .concat(events)
            .forEach(d => 
              samples.push(
                ...Object
                  .keys(d)
                  .filter(idx => 
                    idx !== 'measure' && 
                    idx !== 'evt'     && 
                    idx !== 'type'    && 
                    idx !== 'id'      && 
                    idx !== 'value'   && 
                    idx !== 'timestamp' && 
                    idx !== 'tel'       &&
                    idx !== 'measure'   &&
                    idx !== 'metadata'  && 
                    idx !== 'mtd' 
                  )
            .map(idx => new TelemetrySample(idx, d.timestamp, d[idx]))));

          return new DeviceTelemetry(
            t.id,
            t.label,
            ...samples
          )
        })
      )

      return list.length < 10 ? list : list.slice(list.length - 10);;
    },

    telemetryList() {
      let list = [];
      this.telemetry.forEach((t) => {
        list = list.concat(
          t.data.map((v) => {
            v.id = t.id;
            v.tel = true;
            return v;
          })
        );
      });
      this.events.forEach((e) => {
        list = list.concat(
          e.data.map((v) => {
            v.id = e.id;
            v.evt = true;
            return v;
          })
        );
      });
      return list;
    },

    minSelectedTimestamp() {
      if (this.timestamps.length == 0) return new Date(0);
      return Math.min(...this.timestamps.map((d) => d.getTime()));
    },
    maxSelectedTimestamp() {
      if (this.timestamps.length == 0) return new Date(0);
      return Math.max(...this.timestamps.map((d) => d.getTime()));
    },

    currentPerimeters() {
      return this.perimeters
        .filter(
          (p) =>
            p.length > 0 &&
            this.showGeofence &&
            this.selectedDevices.find((d) => d.id === p[0].deviceId)
        )
        .map((p) => JSON.parse(p[0].perimeter));
    },
  },

  watch: {
    labels(){
      this.showInMaplabels = this.labels.concat([]);
    },

    selectedWkplace() {
      
      if(this.selectedWkplace){
        this.image = new OverlayImage(
          this.selectedWkplace.url, 
          this.selectedWkplace.cornersCoords[3], 
          this.selectedWkplace.cornersCoords[1],
          this.selectedWkplace.bounds[3], 
          this.selectedWkplace.bounds[1],
        );
      } else {
        this.image = null;
      }
 
    },

    selectedWindowTime() {
      this.buildWindowTime();
    },
    "selectedTime.time": function () {
      if (this.selectedTime.time && this.selectedTime.time != "") {
        this.selectedTime.timeObj = new Date(
          Date.parse(this.selectedTime.time) +
            this.timeOffset +
            new Date().getTimezoneOffset() * 60 * 1000
        );
      }
    },

    timeHourStart: function () {
      let ch = this.timeHourStart.split(":");
      let hh = parseInt(ch[0]);
      let mm = parseInt(ch[1]);
      let offset = hh * 60 * 60 * 1000 + mm * 60 * 1000;
      this.selectedStartTime.timeObj = new Date(
        Date.parse(this.selectedStartTime.time) +
          offset +
          new Date().getTimezoneOffset() * 60 * 1000
      );
    },
    timeHourEnd: function () {
      let ch = this.timeHourEnd.split(":");
      let hh = parseInt(ch[0]);
      let mm = parseInt(ch[1]);
      let offset = hh * 60 * 60 * 1000 + mm * 60 * 1000;
      this.selectedEndTime.timeObj = new Date(
        Date.parse(this.selectedEndTime.time) +
          offset +
          new Date().getTimezoneOffset() * 60 * 1000
      );
    },

    selectedComplexTime: function () {
      if (this.selectedComplexTime.length > 2) {
        this.selectedComplexTime.shift();
      }

      let ch = this.timeHourStart.split(":");
      let hh = parseInt(ch[0]);
      let mm = parseInt(ch[1]);
      let startOffset = hh * 60 * 60 * 1000 + mm * 60 * 1000;
      ch = this.timeHourEnd.split(":");
      hh = parseInt(ch[0]);
      mm = parseInt(ch[1]);
      let endOffset = hh * 60 * 60 * 1000 + mm * 60 * 1000;

      this.selectedStartTime.time = this.selectedComplexTime[0];
      this.selectedStartTime.timeObj = new Date(
        Date.parse(this.selectedStartTime.time) +
          startOffset +
          new Date().getTimezoneOffset() * 60 * 1000
      );

      if (this.selectedComplexTime[1]) {
        this.selectedEndTime.time = this.selectedComplexTime[1];
        this.selectedEndTime.timeObj = new Date(
          Date.parse(this.selectedEndTime.time) +
            endOffset +
            new Date().getTimezoneOffset() * 60 * 1000
        );
      }

      if (this.selectedEndTime.timeObj && this.selectedStartTime.timeObj)
        if (
          this.selectedEndTime.timeObj.getTime() <
          this.selectedStartTime.timeObj.getTime()
        ) {
          let temp = this.selectedEndTime;
          this.selectedEndTime = this.selectedStartTime;
          this.selectedStartTime = temp;
        }
    },

    geoLocations: {
      handler() {
        this.openDataPicker = false;
        this.buildGeoLocationsData();
      },
      deep: true,
    },

    selectedDevices: function () {
      this.buildGeoLocationsData();
    },
  },

  mounted(){
    this.showInMaplabels = this.labels.concat([]);
  },

  async destroyed() {
    await this.$store.dispatch("telemetry/stopGeoLocationRealtime");
  },

  methods: {

    selectKnownPlace(){
      if(this.image){
        this.image = null;
        this.markers = [];
      } else {
        this.image = new OverlayImage('http://localhost:8080/assets/known-places/test_image_milan_satellite.PNG', [45.581783, 9.299934], [45.579833, 9.303310]);

        const marker = {
          id: "test_image_overlay",
          coordinates: {latitude:45.581126, longitude:9.301623},
          timestamp: 123456,
          htmlContentTooltip: getHtmlInfo(
            "/assets/technology/http.png",
            "Image overlay test",
            "test_image_overlay",
            new Date(123456),
            {latitude:45.581126, longitude:9.301623}
          ),
        };

        this.markers = [ marker ];
      }
    },

    handleClickMap(coordinates) {

        if(this.newLabelFlag){
          this.setCoordinates(coordinates);
          this.newLabelFlag = false;
        }
    },
    async handleClickLabel(label) {},

    clickMarkerHandler(m) {      
      Vue.set(this, "selectedOnMapDeviceId", m.id);
      Vue.set(this , "showTelemetry" ,  !this.showTelemetry); 
      this.timestamps = [m.timestamp, m.timestamp];
    },

    setCoordinates(coordinates){
      Vue.set(this , "newLabelCoordinates" ,  coordinates);
    },

    async createdPerimeterHandler(e) {
      if(this.selectedDevices.length>0){
        let perimeter = { devices: this.selectedDevices , points: e };
        await this.$store.dispatch("devices/createPerimeter", perimeter);
        await this.$store.dispatch("devices/fetchPerimeters", this.devices);
      } else {
        for(const d of this.devices){
          let perimeter = { devices: [d.id] , points: e };
          await this.$store.dispatch("devices/createPerimeter", perimeter);
          await this.$store.dispatch("devices/fetchPerimeters", this.devices);
        }
      }

    },

    async deleteLabel(l){
      await this.$store.dispatch("map/removeLabel", l);
    },

    async fetchPerimeters() {
      await this.$store.dispatch("devices/fetchPerimeters", this.devices);
    },
    submit: async function () {
      this.openDataPicker = false;
      this.validForm = this.$refs.form.validate();
      if (this.validForm) {
        if (this.geoLocationRealtime)
          await this.$store.dispatch("telemetry/stopGeoLocationRealtime");

        this.buildWindowTime();
        if (this.selectedWindowTime.id != 0)
          await this.$store.dispatch("telemetry/fetchTelemetry", {
            devices: this.selectedDevices,
            startTime: this.selectedStartTime.timeObj,
            endTime: this.selectedEndTime.timeObj,
          });
        if (this.selectedWindowTime.id != 0)
          await this.$store.dispatch("telemetry/fetchEvents", {
            devices: this.selectedDevices,
            startTime: this.selectedStartTime.timeObj,
            endTime: this.selectedEndTime.timeObj,
          });
        await this.$store.dispatch(
          this.selectedWindowTime.id == 0
            ? "telemetry/startGeoLocationRealtime"
            : "telemetry/fetchGeoLocations",
          {
            devices: this.selectedDevices,
            startTime: this.selectedStartTime.timeObj,
            endTime: this.selectedEndTime.timeObj,
          }
        );
        return;
      }
    },

    stopGeoLocationRealtime: async function () {
      await this.$store.dispatch("telemetry/stopGeoLocationRealtime");
    },

    buildGeoLocationsData: function () {
      this.markers.splice(0);
      this.paths.splice(0);

      this.geoLocations
        .filter((geoLocationsDevice) =>
          this.selectedDevices.find(
            (selectedDevice) => selectedDevice.id == geoLocationsDevice.id
          )
        )
        .forEach((geoLocationsDevice) => {
          if (!this.geoLocationRealtime) {
            /*** Case 1: no relatime case: show device paths ***/
            for (let geoLocationIndex in geoLocationsDevice.data) {
              let geoLocation = geoLocationsDevice.data[geoLocationIndex];
              let evt = this.telemetryList.find(
                (t) =>
                  t.evt == true &&
                  t.timestamp.getTime() == geoLocation.timestamp.getTime()
              );
              let tel = this.telemetryList.find(
                (t) =>
                  t.tel == true &&
                  t.timestamp.getTime() == geoLocation.timestamp.getTime()
              );

              let coordinates = {
                latitude: geoLocation.latitude,
                longitude: geoLocation.longitude,
                altitude: geoLocation.altitude,
              };
              let device = this.devices.find(
                (d) => d.id == geoLocationsDevice.id
              );

              let marker = {
                id: geoLocationsDevice.id, //+geoLocation.timestamp,
                coordinates: coordinates,
                timestamp: geoLocation.timestamp,
                evt: evt,
                tel: tel,
                htmlContentTooltip: getHtmlInfo(
                  "/assets/technology/" + device.connectivity + ".png",
                  device.label,
                  device.id,
                  new Date(geoLocation.timestamp),
                  coordinates
                ),
              };

              if (this.typeView == "markers") this.markers.push(marker);
              else {
                let storedPath = this.paths.find(
                  (p) => p.id == geoLocationsDevice.id
                );
                if (storedPath) storedPath.markers.push(marker);
                else
                  this.paths.push({
                    id: geoLocationsDevice.id,
                    markers: [marker],
                  });
              }
            }
          } else {
            /*** Case 2: relatime case: show only markers (with animated movements) ***/
            let geoLocation;
            for (let geoLocationIndex in geoLocationsDevice.data)
              if (!geoLocation)
                geoLocation = geoLocationsDevice.data[geoLocationIndex];
              else if (
                geoLocation.timestamp.getTime() -
                  geoLocationsDevice.data[
                    geoLocationIndex
                  ].timestamp.getTime() <=
                0
              )
                geoLocation = geoLocationsDevice.data[geoLocationIndex];
            if (geoLocation) {
              let coordinates = {
                latitude: geoLocation.latitude,
                longitude: geoLocation.longitude,
                altitude: geoLocation.altitude,
              };
              let device = this.devices.find(
                (d) => d.id == geoLocationsDevice.id
              );
              let marker = {
                id: geoLocationsDevice.id, //+geoLocation.timestamp,
                coordinates: coordinates,
                htmlContentTooltip: getHtmlInfo(
                  "/assets/technology/" + device.connectivity + ".png",
                  device.label,
                  device.id,
                  new Date(geoLocation.timestamp),
                  coordinates
                ),
                fitZoom: false,
              };
              this.markers.push(marker);
            }
          }
        });
    },
    buildWindowTime() {
      let hours = this.selectedWindowTime.id;
      switch (hours) {
        case 0:
          this.selectedStartTime.timeObj = new Date();
          this.selectedEndTime.timeObj = new Date();
          break;
        case -1:
          this.selectedTime = this.selectedStartTime;
          this.timeOffset = 0;
          this.openDataPicker = true;
          break;
        case null:
          break;
        case undefined:
          break;
        default:
          this.selectedEndTime.timeObj = new Date();
          this.selectedStartTime.timeObj = new Date(
            this.selectedEndTime.timeObj.getTime() - hours * 60 * 60 * 1000
          );
          return;
      }
    },
  },
};

function getHtmlInfo(img, customName, id, timestamp, coordinates, widthImg) {
  let title = `
        <div style="height:40px;margin-top:-5px;text-align: left;">
        <img style="background-color:white; float: left;width:5rem;margin-left:-0.4rem" src="${img}"  onerror="this.style.display='none'">
        <div style="float: left;margin:12px;margin-top:7px;align-content: left;">
            <div style="font-weight: bold">${customName}</div>
            <div>${id}</div>
        </div>
        </div>
    `;
  let body = `
        <div style="height:100px;align-content: left;padding:10px">
        <div>
            <span style="position:relative">
                <span class="material-icons" style="font-size:13px;position:absolute;left:0" >date_range</span>
                <span style="font-weight: bold;margin-left:15px">Timestamp:</span>
            </span> 
                ${timestamp.toString().split("GMT")[0]}
        </div>
        <div style="margin-top:3px">
            <span style="position:relative">
                <span class="material-icons" style="font-size:13px;position:absolute;left:0" >my_location</span>
                <span style="font-weight: bold;margin-left:15px">Coordinates:</span>
            </span> 
            <div style="margin-left:25px">
                <div><span style="font-weight: bold">Latitude:</span> ${
                  coordinates.latitude
                }</div>
                <div><span style="font-weight: bold">Longitude:</span>  ${
                  coordinates.longitude
                }</div>
                <div><span style="font-weight: bold">Altitude:</span>  ${
                  coordinates.altitude
                }</div>
            </div>
        </div>
        </div>
    `;
  return {
    title: title,
    body: body,
  };
}
</script>